import { Col } from 'antd';
import { Row } from 'antd';
import { useState } from 'react';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomInputNumber from '../../../../../v2-components/Antd/InputNumber';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import { options } from './constants/options.constant';
import { checkMax } from './handle/check-max.handle';
import { getDisscount } from './handle/get-disscount.handle';
import { prefixHandle } from './handle/prefix.handle';
import { priceHandle } from './handle/price.handle';

export default function EditOfferModal(props) {
	const [disscount, setDisscount] = useState(0);
	const [mechanic, setMechanic] = useState(null);

	const onChangeDisscount = (e) => {
		setDisscount(e);
	};
	const onChangeMechanic = (e) => {
		setMechanic(e);
		setDisscount(0);
	};
	const priceWithDisscountPercentage = getDisscount(props?.record?.unit_price, disscount, props?.record?.quantity);
	const priceStatic = props?.record?.unit_price - disscount;

	const dataHandleEditDiscount = {
		items: [
			{
				code_internal: props?.record?.code_internal,
				price: priceHandle(mechanic, priceWithDisscountPercentage, priceStatic),
				quantity: props?.record?.quantity,
			},
		],
	};

	const handleResetFields = () => {
		props?.setOpenEditOffer(false);
		setDisscount(0);
		setMechanic(null);
	};

	return (
		<CustomModal onCancel={handleResetFields} footer={null} open={props?.openEditOffer}>
			<h2>Detalle descuento</h2>
			<CustomDivider />
			<h3>Datos</h3>
			<Row>
				<Col span={12}>
					<h3>Mecánica</h3>
					<CustomSelect
						bordered={false}
						onChange={onChangeMechanic}
						placeholder="Seleccione mecánica"
						className="default"
						options={options}
					/>
				</Col>
				<Col span={12}>
					<h3>Beneficio</h3>
					<CustomInputNumber
						onChange={onChangeDisscount}
						placeholder="Seleccione descuento"
						prefix={prefixHandle(mechanic)}
						disabled={!mechanic}
						defaultValue={0}
						value={disscount}
						min={0}
						max={checkMax(mechanic, props)}
					/>
				</Col>
			</Row>
			<CustomDivider />
			<div className="button-container">
				<CustomButton onClick={() => handleResetFields()}>Cancelar</CustomButton>
				<CustomButton onClick={() => props?.handleConfirmOffer(dataHandleEditDiscount)}>Guardar </CustomButton>
			</div>
		</CustomModal>
	);
}
